// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import Button from "react-bootstrap/Button";
// import Form from "react-bootstrap/Form";
// import NavigationBar from "../../Components/NavigationBar";
// import axios from "axios";

// export default function SendEmailDean() {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
//    const FRONTEND_BASE_URL = process.env.REACT_APP_FRONTEND_BASE_URL;

//   const { applicationId, awardType } = location.state || {};

//   console.log("Received data:", { applicationId, awardType });

//   const [recipientName, setRecipientName] = useState("");
//   const [recipientEmail, setRecipientEmail] = useState("");
//   const [emailSubject, setEmailSubject] = useState("");
//   const [emailBody, setEmailBody] = useState("");

//   // Create the email link for both the recipient and sender
//   const emailLink = `${FRONTEND_BASE_URL}/deanapproval?applicationId=${applicationId}&role=Dean`;

//   // Set default subject and body when component loads
//   useEffect(() => {
//     if (awardType) {
//       console.log("Setting email body with award type:", awardType);
//       setEmailSubject(`Approval of a candidate for the Professor Lakshman Samaranayake Research Excellence Award`);

//       // Set default email body with the link
//       const defaultBody = `Dear Dean,\n\nThis application has been submitted by one/more of your faculty members for the Professor Lakshman Samaranayake Research Excellence Award. To proceed with the evaluation process, we kindly request the Faculty Board’s selection and approval of a candidate for this award.
//       \nThe following is an extract from the regulation governing this award:
// o	The Award(s) will be available to academic staff who are active in research and are in the permanent cadre of the University of Peradeniya (hereinafter referred to as “the candidate/s”) The candidate/s shall supply evidence of research at the highest international level in the form of : 
// 	(i) documented evidence of international recognition of research accomplishments such as publications in high impact factor venues, H – Index etc. 
// 	(ii) quality and quantity of research publications; 
// 	(iii) supply the evidence in the form of research grants, taking into account the prestige of the funding bodies and the size of the grants awarded; and 
// 	(iv) high – impacted applied research work including acclaimed creative arts, productions and innovation. 
// o	Once the awards are advertised, the candidate/s for the Award(s) shall either apply in person or be nominated by the Dean of the Faculty. 
// o	Dean must constitute a Faculty Sub-Committee for the selection of research excellence award with at least two senior professors / professors of the Faculty on the recommendations of the Faculty Board using a marking scheme approved by the Faculty Board for the said purpose and rank them with justifications. 
// \nPlease ensure that the Faculty Board reviews the candidates’ suitability and approves one candidate for the award. Kindly provide an extract of the Faculty Board minutes documenting the approval. 
// Should you require further clarification or additional information, please contact [secretaryurc@gs.pdn.ac.lk]. We appreciate your prompt attention to this matter to ensure the timely processing of the nomination.
// \nClick the link below to proceed:\n${emailLink}\n\n This is a System Generated Email.Please Don't reply.\n\nBest Regards,\nDirector URC`;
//       setEmailBody(defaultBody);
//     }
//   }, [awardType, emailLink]);

//   const handleSendEmail = async () => {
//     const updatedEmailBody = `
//       Dear Dean,\n\nThis application has been submitted by one/more of your faculty members for the Professor Lakshman Samaranayake Research Excellence Award. To proceed with the evaluation process, we kindly request the Faculty Board’s selection and approval of a candidate for this award.
//       \nThe following is an extract from the regulation governing this award:
// o	The Award(s) will be available to academic staff who are active in research and are in the permanent cadre of the University of Peradeniya (hereinafter referred to as “the candidate/s”) The candidate/s shall supply evidence of research at the highest international level in the form of : 
// 	(i) documented evidence of international recognition of research accomplishments such as publications in high impact factor venues, H – Index etc. 
// 	(ii) quality and quantity of research publications; 
// 	(iii) supply the evidence in the form of research grants, taking into account the prestige of the funding bodies and the size of the grants awarded; and 
// 	(iv) high – impacted applied research work including acclaimed creative arts, productions and innovation. 
// o	Once the awards are advertised, the candidate/s for the Award(s) shall either apply in person or be nominated by the Dean of the Faculty. 
// o	Dean must constitute a Faculty Sub-Committee for the selection of research excellence award with at least two senior professors / professors of the Faculty on the recommendations of the Faculty Board using a marking scheme approved by the Faculty Board for the said purpose and rank them with justifications. 
// \nPlease ensure that the Faculty Board reviews the candidates’ suitability and approves one candidate for the award. Kindly provide an extract of the Faculty Board minutes documenting the approval. 
// Should you require further clarification or additional information, please contact [secretaryurc@gs.pdn.ac.lk]. We appreciate your prompt attention to this matter to ensure the timely processing of the nomination.
// \nClick the link below to proceed:\n${emailLink}\n\n This is a System Generated Email.Please Don't reply.\n\nBest Regards,\nDirector URC
//     `;

//     setEmailBody(updatedEmailBody);

//     // Simulate sending email
//     alert("Email sent successfully!");

//     try {
//       await axios.post(`${API_BASE_URL}/saveDeanEmailDetails`, {
//         App_Id: applicationId,
//         Dean_Name: recipientName,
//         Dean_Email: recipientEmail,
//         Sent: 1,
//       });

//       console.log("Dean email record saved.");
//     } catch (error) {
//       console.error("Failed to save dean email record:", error);
//       alert("Failed to save email record to database.");
//     }

//     navigate("/approveawards");
//   };

//   return (
//     <div>
//       <NavigationBar />
//       <div className="container mt-4">
//         <h2 className="page-name">Send Email</h2>
//         <Form>
//           <Form.Group className="mb-3">
//             <Form.Label>Award Type</Form.Label>
//             <Form.Control type="text" value={awardType} readOnly />
//           </Form.Group>

//           <Form.Group className="mb-3">
//             <Form.Label>Recipient Name</Form.Label>
//             <Form.Control
//               type="text"
//               value={recipientName}
//               onChange={(e) => setRecipientName(e.target.value)}
//               placeholder="Enter recipient's name"
//             />
//           </Form.Group>

//           <Form.Group className="mb-3">
//             <Form.Label>Recipient Email</Form.Label>
//             <Form.Control
//               type="email"
//               value={recipientEmail}
//               onChange={(e) => setRecipientEmail(e.target.value)}
//               placeholder="Enter recipient's email"
//             />
//           </Form.Group>

//           <Form.Group className="mb-3">
//             <Form.Label>Email Subject</Form.Label>
//             <Form.Control
//               type="text"
//               value={emailSubject}
//               onChange={(e) => setEmailSubject(e.target.value)}
//             />
//           </Form.Group>

//           <Form.Group className="mb-3">
//             <Form.Label>Email Body</Form.Label>
//             <Form.Control
//               as="textarea"
//               rows={6}
//               value={emailBody}
//               onChange={(e) => setEmailBody(e.target.value)}
//             />
//           </Form.Group>

//           {/* Display the email link for the sender */}
//           <div>
//             <p className="emaillink" style={{ color: "black" }}>
//               <strong>Email Link (For Senders Reference):</strong>
//             </p>
//             <a
//               href={emailLink}
//               target="_blank"
//               rel="noopener noreferrer"
//               style={{ color: "black" }}
//             >
//               {emailLink}
//             </a>
//           </div>

//           <Button
//             variant="primary"
//             className="Send_Button"
//             onClick={handleSendEmail}
//           >
//             Send
//           </Button>
//         </Form>
//       </div>
//     </div>
//   );
// }
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import NavigationBar from "../../Components/NavigationBar";
import axios from "axios";

export default function SendEmailDean() {
  const location = useLocation();
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';
  const FRONTEND_BASE_URL = process.env.REACT_APP_FRONTEND_BASE_URL || 'http://localhost:3000';

  const { applicationId, awardType } = location.state || {};

  console.log("Received data:", { applicationId, awardType });

  const [recipientName, setRecipientName] = useState("");
  const [recipientEmail, setRecipientEmail] = useState("");
  const [emailSubject, setEmailSubject] = useState("");
  const [emailBody, setEmailBody] = useState("");

  // Create the email link for both the recipient and sender
  const emailLink = applicationId
    ? `${FRONTEND_BASE_URL}/deanapproval?applicationId=${applicationId}&role=Dean`
    : "";

  // Set default subject and body when component loads
  useEffect(() => {
    if (awardType) {
      console.log("Setting email body with award type:", awardType);
      setEmailSubject(`Approval of a candidate for the Professor Lakshman Samaranayake Research Excellence Award`);

      const defaultBody = `Dear Dean,\n\nThis application has been submitted by one/more of your faculty members for the Professor Lakshman Samaranayake Research Excellence Award. To proceed with the evaluation process, we kindly request the Faculty Board’s selection and approval of a candidate for this award.\n\nThe following is an extract from the regulation governing this award:\n\no\tThe Award(s) will be available to academic staff who are active in research and are in the permanent cadre of the University of Peradeniya (hereinafter referred to as “the candidate/s”). The candidate/s shall supply evidence of research at the highest international level in the form of:\n\t(i) documented evidence of international recognition of research accomplishments such as publications in high impact factor venues, H – Index etc.\n\t(ii) quality and quantity of research publications;\n\t(iii) supply the evidence in the form of research grants, taking into account the prestige of the funding bodies and the size of the grants awarded; and\n\t(iv) high – impacted applied research work including acclaimed creative arts, productions and innovation.\n\no\tOnce the awards are advertised, the candidate/s for the Award(s) shall either apply in person or be nominated by the Dean of the Faculty.\no\tDean must constitute a Faculty Sub-Committee for the selection of research excellence award with at least two senior professors / professors of the Faculty on the recommendations of the Faculty Board using a marking scheme approved by the Faculty Board for the said purpose and rank them with justifications.\n\nPlease ensure that the Faculty Board reviews the candidates’ suitability and approves one candidate for the award. Kindly provide an extract of the Faculty Board minutes documenting the approval.\nShould you require further clarification or additional information, please contact [secretaryurc@gs.pdn.ac.lk]. We appreciate your prompt attention to this matter to ensure the timely processing of the nomination.\n\nClick the link below to proceed:\n${emailLink}\n\nThis is a System Generated Email. Please Do Not Reply.\n\nBest Regards,\nDirector URC`;
      setEmailBody(defaultBody);
    }
  }, [awardType, emailLink]);

  const handleSendEmail = async () => {
    if (!recipientName || !recipientEmail) {
      alert("Please fill in recipient name and email.");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(recipientEmail)) {
      alert("Please enter a valid email address.");
      return;
    }

    const updatedEmailBody = `Dear Dean,\n\nThis application has been submitted by one/more of your faculty members for the Professor Lakshman Samaranayake Research Excellence Award. To proceed with the evaluation process, we kindly request the Faculty Board’s selection and approval of a candidate for this award.\n\nThe following is an extract from the regulation governing this award:\no\tThe Award(s) will be available to academic staff who are active in research and are in the permanent cadre of the University of Peradeniya (hereinafter referred to as “the candidate/s”). The candidate/s shall supply evidence of research at the highest international level in the form of:\n\t(i) documented evidence of international recognition of research accomplishments such as publications in high impact factor venues, H – Index etc.\n\t(ii) quality and quantity of research publications;\n\t(iii) supply the evidence in the form of research grants, taking into account the prestige of the funding bodies and the size of the grants awarded; and\n\t(iv) high – impacted applied research work including acclaimed creative arts, productions and innovation.\no\tOnce the awards are advertised, the candidate/s for the Award(s) shall either apply in person or be nominated by the Dean of the Faculty.\no\tDean must constitute a Faculty Sub-Committee for the selection of research excellence award with at least two senior professors / professors of the Faculty on the recommendations of the Faculty Board using a marking scheme approved by the Faculty Board for the said purpose and rank them with justifications.\n\nPlease ensure that the Faculty Board reviews the candidates’ suitability and approves one candidate for the award. Kindly provide an extract of the Faculty Board minutes documenting the approval.\nShould you require further clarification or additional information, please contact [secretaryurc@gs.pdn.ac.lk]. We appreciate your prompt attention to this matter to ensure the timely processing of the nomination.\n\nClick the link below to proceed:\n${emailLink}\n\nThis is a System Generated Email. Please Do Not Reply.\n\nBest Regards,\nDirector URC`;

    try {
      // Save email details for the Dean
      await axios.post(`${API_BASE_URL}/saveDeanEmailDetails`, {
        App_Id: applicationId,
        Dean_Name: recipientName,
        Dean_Email: recipientEmail,
        Sent: 1,
      });

      // Send email via nodemailer
      const response = await axios.post(`${API_BASE_URL}/sendEmail`, {
        to: recipientEmail,
        subject: emailSubject,
        text: updatedEmailBody,
        html: `<p>${updatedEmailBody.replace(/\n/g, '<br>')}</p>`,
      });

      alert(response.data.message); // e.g., "Email sent successfully"
      navigate("/approveawards");
    } catch (error) {
      console.error("Failed to send email or save record:", error);
      alert("Failed to send email. Please try again.");
    }
  };

  return (
    <div>
      <NavigationBar />
      <div className="container mt-4">
        <h2 className="page-name">Send Email</h2>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Award Type</Form.Label>
            <Form.Control type="text" value={awardType || ""} readOnly />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Recipient Name</Form.Label>
            <Form.Control
              type="text"
              value={recipientName}
              onChange={(e) => setRecipientName(e.target.value)}
              placeholder="Enter recipient's name"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Recipient Email</Form.Label>
            <Form.Control
              type="email"
              value={recipientEmail}
              onChange={(e) => setRecipientEmail(e.target.value)}
              placeholder="Enter recipient's email"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Email Subject</Form.Label>
            <Form.Control
              type="text"
              value={emailSubject}
              onChange={(e) => setEmailSubject(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Email Body</Form.Label>
            <Form.Control
              as="textarea"
              rows={6}
              value={emailBody}
              onChange={(e) => setEmailBody(e.target.value)}
            />
          </Form.Group>

          <div className="mb-3">
            <p className="emaillink" style={{ color: "black" }}>
              <strong>Email Link (For Sender's Reference):</strong>
            </p>
            <a
              href={emailLink}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "black" }}
            >
              {emailLink}
            </a>
          </div>

          <Button
            variant="primary"
            className="Send_Button"
            onClick={handleSendEmail}
            disabled={!applicationId || !awardType}
          >
            Send
          </Button>
        </Form>
      </div>
    </div>
  );
}